// src/rms/components/Brandmark.jsx
// ============================================================================
// The logo lockup
// ============================================================================
// Six screens used to render `<span className="dot" /> ReserveZoo` -- a plain
// coloured square standing in for a logo we did not have. They now share this.
//
// The mark is drawn with a CSS mask rather than an <img>, so it takes its
// colour from `currentColor`. That matters because the same mark has to sit on
// a white sidebar and on the navy footer, and a flat navy PNG disappears on
// navy. Masking is also pixel-accurate to the supplied artwork, which
// hand-tracing an SVG would not have been.
//
// "ReserveZoo" is a proper noun and is never translated -- the checker's
// IGNORE list has carried it from the start.
// ============================================================================

import React from "react";

export default function Brandmark({ size = 26, tone = "brand", className = "", style }) {
  return (
    <span className={`rms-brandmark rms-brandmark--${tone} ${className}`} style={style}>
      <span
        className="rms-brandmark-icon"
        aria-hidden="true"
        style={{ width: size, height: size }}
      />
      <span className="rms-brandmark-word">
        Reserve<span className="rms-brandmark-zoo">Zoo</span>
      </span>
    </span>
  );
}
